import { Component, Input } from '@angular/core';
import { BookingWidgetComponent } from "./booking-widget/booking-widget.component";
import { asapScheduler } from 'rxjs';
import { CommonModule } from '@angular/common';
import { BookingWidgetTransferComponent } from "./booking-widget-transfer/booking-widget-transfer.component";
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    BookingWidgetComponent,
    CommonModule,
    BookingWidgetTransferComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  // @Input() external_channel: any;
  // @Input() api_url: any;
  // @Input() channelactivitycode: any;
  // @Input() productid: any;
  // @Input() producttype: any;
  // @Input() web_city: any;
  // @Input() lang: any;
  // @Input() public_key: any;
  // @Input() seller: any = 11;
  // @Input() channelactivitycode: any = '0f641d85-2046-11e7-9cc9-06a7e332783f'; // 515592 Variable ID PRODUCTO EN TOUR2B: 42, 531

  @Input() seller: any;
  @Input() connector: any; // variable: geant / hub2b
  @Input() external_channel: any; // variable: musement_pull / tour2b / venntur / discoverysafari / suntransfers_pull
  @Input() api_url: any; //'https://api.touringmalaga.hub2b.travel'; // variable: https://api.actividadesencanfranc.hub2b.travel / https://api.venntur.hub2b.travel / https://api.discoverysafari.hub2b.travel / https://api.tour2b.hub2b.aititubi.es
  @Input() channelactivitycode: any; // 515592 Variable ID PRODUCTO EN TOUR2B: 42, 531
  @Input() isOpenDate: any;
  @Input() productid: any; // 104 Variable ID PRODUCTO EN B2C: 30, 51
  @Input() producttype: any; // Variable: Activity / Transfer
  @Input() web_city: any; // Variable: Can Franc
  @Input() lang: any; // Variable: es / en
  @Input() public_key: any; // Variable: pk_test_cycICGEq4Nfma9OeiFOB2rmU00Lapr8BSK / pk_live_z31RtXGJKEPg0Q4EWzIBZfYr00pHmRWYkO / (Clave hub2b aititubi test) pk_test_my9mJE7a5hoQWNV7HSnFvCY0
  @Input() success_url: any; // Variable: pk_test_cycICGEq4Nfma9OeiFOB2rmU00Lapr8BSK / pk_live_z31RtXGJKEPg0Q4EWzIBZfYr00pHmRWYkO
  @Input() error_url: any;
  // @Input() public_key: any = 'pk_live_z31RtXGJKEPg0Q4EWzIBZfYr00pHmRWYkO'; // Variable: pk_test_cycICGEq4Nfma9OeiFOB2rmU00Lapr8BSK
}

// VARIABLES QUE PUEDE SOLICITAR EL WIDGET
// =======================================

// external_channel

// API utilizada en los widgets que venden producto propio para consultar disponibilidad
// Cuando el valor coincide con un trozo de api_url, significa que el widget está vendiendo
// producto propio.
// Ejemplo: Touring Malaga vende producto de Tour2B. Su external_channel = "tour2b"


// api_url

// Definición segura para saber desde que api parte el widget.
// Si el widget quiere vender producto propio, también es la API utilizada para consultar
// disponibilidad, y una parte de su valor coincidirá con external_channel.


// channelactivityCode

// ID de producto en sistema externo.
// Ejemplo: Touring Malaga vende un producto de Tour2B. En ese caso channelActivityCode tendría
// el valor de ese id de producto en Tour2B. Para productos de integración pasaría lo mismo, por ejemplo
// para musement valdría algo como "0f641d85-2046-11e7-9cc9-06a7e332783f"


// productid

// ID de producto en API de partida (api_url).
// Ejemplo: para un producto de Touring Malaga, productid valdría lo mismo que el id de dicho producto
// en el API de Touring Malaga.
// Si una web vendiera producto de Tour2B utilizando un widget como por ejemplo lo hace Cuevas,
// productid valdría lo que vale el id del producto en el API de Tour2B.


// producttype

// Tipo de producto que ofrece el widget. Único valor aceptado actualmente es "Activity".


// web_city

// Campo únicamente utilizado en un placeholder del input de ubicación del cliente:
// Dónde te vas a alojar en {{web_city}}?


// lang

// Idioma en el que queremos presentar el widget. 'en', 'es', 'de'...
// Hay que tener en cuenta que para que la información se presente correctamente en un idioma, ese producto
// debe contar con unos contenidos traducidos a dicho idioma en su API (api_url)


// public_key

// Public Key de Stripe para pagos mediante la plataforma. Puede ser de TEST o de LIVE y debe concordar
// con la Secret Key que se define en la API en la que realizamos las reservas.


// seller

// ID de vendedor en API de partida (api_url). Se utiliza para asignar reservas a vendedores, y para pagos en
// cash. Dependiendo del seller que asignemos, el widget cargará la configuración (colores y más parametros
// de configuración) del afiliado al que pertenezca. Si no se asigna un seller, se asigna un seller por defecto
// en base a la primera configuración ([0]) del API de partida.


// connector

// Variable que define a que sistema se apunta para realizar varias llamadas (búsqueda de disponibilidad,
// generación de reservas, confirmar, cancelar, pickups, datos cliente) dependiendo del producto. Normalmente
// valdrá "geant" en productos integrados. En el resto de casos, valdrá "hub2b"


// isOpenDate

// Variable que define si un producto se puede reservar con o sin fecha definida. Si vale false, la actividad
// necesita fecha para poderse reservar. Si vale true, no. Por ahora esta funcionalidad solo es necesaria
// en productos integrados desde Musement.
